
import { useEffect } from "react";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import WorkflowSection from "@/components/landing/WorkflowSection";
import CtaSection from "@/components/landing/CtaSection";
import Footer from "@/components/landing/Footer";
import { useMetadata } from "@/hooks/useMetadata";
import { APP_METADATA } from "@/constants/metadata";

const Index = () => {
  const { title, description, image } = APP_METADATA.home;
  useMetadata({ title, description, image });

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <FeaturesSection />
      <WorkflowSection />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Index;
